import { PATH_NAME } from 'configs/pathName';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useContext, useState } from 'react';
import { SocketContext } from '../../socket/socket-context';
import AuthContext from '../../state/auth/AuthContext';

const LoginModal = dynamic(() => import('./LoginModal2'));

export const QuickLoginModalHOC = ({
  children,
  classname = '',
  handleClickWhenDisabledQuickLogin = () => {},
  loginSuccessCb: _loginSuccessCb,
  disabled,
}: {
  children: React.ReactNode;
  classname?: string;
  handleClickWhenDisabledQuickLogin?: Function;
  loginSuccessCb?: Function;
  disabled?: boolean;
}) => {
  const [openLoginModal, setOpenLoginModal] = useState<boolean>(false);

  const { handleConnect } = useContext(SocketContext);
  const router = useRouter();

  const loginSuccessCb = () => {
    handleConnect();
    if (router.pathname === PATH_NAME.LIBRARY_DOCUMENT_DETAIL) {
      router.reload();
    }
    _loginSuccessCb && _loginSuccessCb();
  };

  const { isLoggedIn } = useContext(AuthContext);

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (!isLoggedIn()) {
      e.preventDefault();
      e.stopPropagation();
      setOpenLoginModal(true);
    } else {
      handleClickWhenDisabledQuickLogin();
    }
  };
  return (
    <React.Fragment>
      <div onClick={handleClick} className={classname}>
        {children}
      </div>
      {openLoginModal && (
        <LoginModal
          open={openLoginModal}
          setOpen={setOpenLoginModal}
          successCb={loginSuccessCb}
        />
      )}
    </React.Fragment>
  );
};
